import React from 'react';
import PropTypes from 'prop-types';
import SelectBox from '@adsk/alloy-select-box';
import TextInput from '@adsk/alloy-react-text-input';
import FormField from '@adsk/alloy-react-form-field';
import { useLocale } from '@adsk/alloy-react-helpers';
import { CURRENCIES } from '@common/constants';
import FieldWrapper from '../FieldWrapper';
import {
  flexWrapperStyle,
  firstColumnFieldStyle,
  flexEndFieldStyle,
} from './styles';

const MonateryValueField = ({
  currencies,
  currencyValue,
  errorMessage,
  isEditing,
  onCurrencyChange,
  onValueChange,
  title,
  value,
}) => {
  const { T, locale: localeName } = useLocale(({ locale }) =>
    require(`../../../../i18n/${locale}.json`)
  );
  let content = T.translate('PROJECT_NOT_AVAILABLE');

  if (isEditing) {
    content = (
      <div css={flexWrapperStyle}>
        <FormField style={firstColumnFieldStyle} error={errorMessage}>
          <TextInput
            error={errorMessage.length > 0}
            type="text"
            placeholder={T.translate('PROJECT_VALUE_PLACEHOLDER')}
            onChange={onValueChange}
            value={value}
          />
        </FormField>
        <div css={flexEndFieldStyle}>
          <SelectBox
            defaultValue={{ value: CURRENCIES[0] }}
            value={currencyValue && { value: currencyValue }}
            onChange={onCurrencyChange}
            options={currencies}
          />
        </div>
      </div>
    );
  } else if (value && currencyValue && typeof value === 'number') {
    content = new Intl.NumberFormat(localeName, {
      style: 'currency',
      currency: currencyValue,
    }).format(value);
  }

  return (
    <FieldWrapper title={title} isEditing={isEditing}>
      {content}
    </FieldWrapper>
  );
};

MonateryValueField.propTypes = {
  currencies: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    })
  ),
  currencyValue: PropTypes.string,
  errorMessage: PropTypes.string,
  isEditing: PropTypes.bool,
  onCurrencyChange: PropTypes.func,
  onValueChange: PropTypes.func,
  title: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default MonateryValueField;
